<template>
  <h1 class="pt-0">
    {{ title }}
  </h1>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
